import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useDispatch, useSelector } from 'react-redux';
import { SectionV2Preview, SectionPinnedShortcut, QuestionDisplayAsList, QuestionDisplayAsCarousel, HeadingV2Preview } from '@module/form-components';
import { UPDATE_SELECTED_QUESTION_INDEX } from '../../../redux/root.action';
import { useMemo } from 'react';
import { Skeleton } from 'antd';
import { Headings, QuestionReleases, Questions, SectionDisplayType } from '@module/form';
import Image from 'next/image';
import { QuestionsPreviewContainer, QuestionPreviewItem } from '../questions';
import { createSectionPreviewDisplay } from './section-preview-display.mapper';
import styled from 'styled-components';
import { getSize } from '@lib/common';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var HeadingPreviewWrapper = styled.div.withConfig({
  displayName: "section-previewcontainer__HeadingPreviewWrapper",
  componentId: "sc-3s4f2m-0"
})(["margin-bottom:", ";"], getSize('padding16'));

var orderQuestionsBySectionSummaries = function orderQuestionsBySectionSummaries(questions, sections) {
  var ordered = [];
  var usedIds = new Set(); // Match section summary UI order (array order = Section 1, 2, 3...)

  sections.forEach(function (section) {
    questions.filter(function (q) {
      var _q$sectionId;

      return ((_q$sectionId = q.sectionId) === null || _q$sectionId === void 0 ? void 0 : _q$sectionId.toString()) === section.id.toString();
    }).forEach(function (q) {
      ordered.push(q);
      usedIds.add(q.id.toString());
    });
  });
  questions.forEach(function (q) {
    if (!usedIds.has(q.id.toString())) {
      ordered.push(q);
    }
  });
  return ordered;
};

export var SectionPreviewContainer = function SectionPreviewContainer(_ref) {
  var _page$questions, _page$selectedSection, _page$selectedQuestio, _page$sectionSummarie, _formPreviewLabels$pr2;

  var section = _ref.section,
      onPin = _ref.onPin,
      pinnedSectionId = _ref.pinnedSectionId,
      onCancelPin = _ref.onCancelPin,
      onPinQuestion = _ref.onPinQuestion,
      pinnedQuestionId = _ref.pinnedQuestionId,
      formPreviewLabels = _ref.formPreviewLabels,
      onNextSection = _ref.onNextSection,
      onPreviousSection = _ref.onPreviousSection,
      navigationLabels = _ref.navigationLabels,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'normal-form' : _ref$type,
      _ref$isApplySectionDi = _ref.isApplySectionDisplayType,
      isApplySectionDisplayType = _ref$isApplySectionDi === void 0 ? true : _ref$isApplySectionDi;
  // Selectors
  var dispatch = useDispatch();
  var page = useSelector(function (state) {
    return state.formPreviewApp;
  });
  var questions = (_page$questions = page === null || page === void 0 ? void 0 : page.questions) !== null && _page$questions !== void 0 ? _page$questions : [];
  var form = page === null || page === void 0 ? void 0 : page.form;
  var selectedSectionIndex = (_page$selectedSection = page === null || page === void 0 ? void 0 : page.selectedSectionIndex) !== null && _page$selectedSection !== void 0 ? _page$selectedSection : 0;
  var selectedQuestionIndex = (_page$selectedQuestio = page === null || page === void 0 ? void 0 : page.selectedQuestionIndex) !== null && _page$selectedQuestio !== void 0 ? _page$selectedQuestio : 0;
  var sectionSummaries = (_page$sectionSummarie = page === null || page === void 0 ? void 0 : page.sectionSummaries) !== null && _page$sectionSummarie !== void 0 ? _page$sectionSummarie : [];
  var isFirstSection = !sectionSummaries || selectedSectionIndex <= 0;
  var isLastSection = !sectionSummaries || selectedSectionIndex >= sectionSummaries.length - 1;
  var displaySection = useMemo(function () {
    return createSectionPreviewDisplay(section, formPreviewLabels === null || formPreviewLabels === void 0 ? void 0 : formPreviewLabels.presentation);
  }, [section, formPreviewLabels === null || formPreviewLabels === void 0 ? void 0 : formPreviewLabels.presentation]);
  var sectionLabel = useMemo(function () {
    var _formPreviewLabels$se, _formPreviewLabels$pr;

    return _objectSpread(_objectSpread({
      audio: formPreviewLabels === null || formPreviewLabels === void 0 ? void 0 : (_formPreviewLabels$se = formPreviewLabels.section) === null || _formPreviewLabels$se === void 0 ? void 0 : _formPreviewLabels$se.audio
    }, formPreviewLabels === null || formPreviewLabels === void 0 ? void 0 : formPreviewLabels.section), formPreviewLabels === null || formPreviewLabels === void 0 ? void 0 : (_formPreviewLabels$pr = formPreviewLabels.presentation) === null || _formPreviewLabels$pr === void 0 ? void 0 : _formPreviewLabels$pr.sectionDisplay);
  }, [formPreviewLabels === null || formPreviewLabels === void 0 ? void 0 : (_formPreviewLabels$pr2 = formPreviewLabels.presentation) === null || _formPreviewLabels$pr2 === void 0 ? void 0 : _formPreviewLabels$pr2.sectionDisplay, formPreviewLabels === null || formPreviewLabels === void 0 ? void 0 : formPreviewLabels.section]);

  var renderSection = function renderSection() {
    if (!section) {
      return /*#__PURE__*/_jsx(Skeleton, {
        paragraph: {
          rows: 3
        }
      });
    }

    var showSectionShortcut = pinnedSectionId === section.id.toString();

    if (showSectionShortcut && formPreviewLabels !== null && formPreviewLabels !== void 0 && formPreviewLabels.sectionPinnedShortcut) {
      return /*#__PURE__*/_jsx(SectionPinnedShortcut, {
        section: displaySection,
        sectionDisplayIndex: selectedSectionIndex,
        labels: formPreviewLabels.sectionPinnedShortcut,
        sectionWord: sectionLabel.section,
        onUnpinSection: function onUnpinSection() {
          return onCancelPin === null || onCancelPin === void 0 ? void 0 : onCancelPin();
        }
      });
    }

    return /*#__PURE__*/_jsx(SectionV2Preview, {
      section: displaySection,
      sectionLabel: sectionLabel,
      PinIcon: /*#__PURE__*/_jsx(Image, {
        src: "/icons/pin.svg",
        alt: "pin",
        width: 20,
        height: 20
      }),
      onPinSection: onPin,
      pinnedSectionId: pinnedSectionId,
      onCancelPin: onCancelPin,
      audioPlayerLabels: formPreviewLabels === null || formPreviewLabels === void 0 ? void 0 : formPreviewLabels.audioPlayer,
      readonly: true,
      disableAudioRules: true
    });
  };

  var filterQuestions = useMemo(function () {
    if (!form) {
      return [];
    }

    var sections = sectionSummaries !== null && sectionSummaries !== void 0 && sectionSummaries.length ? sectionSummaries : form.sections || [];

    if (type === 'form-release') {
      return QuestionReleases.sortQuestionsWithIndexBySectionsOrder(questions, sections).filter(function (q) {
        return q.sectionId === section.id.toString();
      });
    }

    var orderedQuestions = orderQuestionsBySectionSummaries(questions, sections);
    return Questions.sortQuestionsWithIndexAndSection(orderedQuestions).filter(function (q) {
      return q.sectionId === section.id.toString();
    });
  }, [form, questions, section, sectionSummaries, type]);
  var sectionHeadings = useMemo(function () {
    if (!form) return [];
    return Headings.sort(form.headings.filter(function (h) {
      return h.sectionId === section.id.toString();
    }));
  }, [form, section.id]);
  var carouselItems = useMemo(function () {
    if (!form) return [];
    return filterQuestions.map(function (question, index) {
      var _formPreviewLabels$pr3, _formPreviewLabels$pr4;

      return /*#__PURE__*/_jsx(QuestionPreviewItem, {
        question: question,
        index: index,
        labels: _objectSpread(_objectSpread({}, formPreviewLabels === null || formPreviewLabels === void 0 ? void 0 : formPreviewLabels.question), formPreviewLabels === null || formPreviewLabels === void 0 ? void 0 : formPreviewLabels.matchingQuestion),
        speakingLabel: formPreviewLabels === null || formPreviewLabels === void 0 ? void 0 : (_formPreviewLabels$pr3 = formPreviewLabels.presentation) === null || _formPreviewLabels$pr3 === void 0 ? void 0 : _formPreviewLabels$pr3.speaking,
        questionDescriptionLabel: formPreviewLabels === null || formPreviewLabels === void 0 ? void 0 : (_formPreviewLabels$pr4 = formPreviewLabels.presentation) === null || _formPreviewLabels$pr4 === void 0 ? void 0 : _formPreviewLabels$pr4.questionDescription,
        onPin: onPinQuestion,
        pinnedQuestionId: pinnedQuestionId,
        onCancelPin: onCancelPin,
        audioPlayerLabels: formPreviewLabels === null || formPreviewLabels === void 0 ? void 0 : formPreviewLabels.audioPlayer
      }, question.id.toString());
    });
  }, [form, filterQuestions, formPreviewLabels, onPinQuestion, pinnedQuestionId, onCancelPin]);

  var renderQuestions = function renderQuestions() {
    var _formPreviewLabels$pr5, _formPreviewLabels$pr6;

    if (!form) {
      return /*#__PURE__*/_jsx(Skeleton, {
        paragraph: {
          rows: 10
        }
      });
    }

    var filterHeadings = Headings.sort(form.headings.filter(function (h) {
      return h.sectionId === section.id.toString();
    }));
    var filterQuestionsWithHeadings = Headings.sortWithQuestions(filterHeadings, filterQuestions);
    return /*#__PURE__*/_jsx(QuestionsPreviewContainer, {
      questionsWithHeadings: filterQuestionsWithHeadings,
      onPin: onPinQuestion,
      pinnedQuestionId: pinnedQuestionId,
      onCancelPin: onCancelPin,
      labels: _objectSpread(_objectSpread({}, formPreviewLabels === null || formPreviewLabels === void 0 ? void 0 : formPreviewLabels.question), formPreviewLabels === null || formPreviewLabels === void 0 ? void 0 : formPreviewLabels.matchingQuestion),
      audioPlayerLabels: formPreviewLabels === null || formPreviewLabels === void 0 ? void 0 : formPreviewLabels.audioPlayer,
      speakingLabel: formPreviewLabels === null || formPreviewLabels === void 0 ? void 0 : (_formPreviewLabels$pr5 = formPreviewLabels.presentation) === null || _formPreviewLabels$pr5 === void 0 ? void 0 : _formPreviewLabels$pr5.speaking,
      questionDescriptionLabel: formPreviewLabels === null || formPreviewLabels === void 0 ? void 0 : (_formPreviewLabels$pr6 = formPreviewLabels.presentation) === null || _formPreviewLabels$pr6 === void 0 ? void 0 : _formPreviewLabels$pr6.questionDescription
    });
  };

  var isCarouselMode = isApplySectionDisplayType && SectionDisplayType.isCarousel(section === null || section === void 0 ? void 0 : section.displayType);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [renderSection(), /*#__PURE__*/_jsx("br", {}), isCarouselMode ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [sectionHeadings.map(function (heading) {
        return /*#__PURE__*/_jsx(HeadingPreviewWrapper, {
          id: heading.id.toString(),
          children: /*#__PURE__*/_jsx(HeadingV2Preview, {
            heading: heading,
            readonly: true
          })
        }, heading.id.toString());
      }), /*#__PURE__*/_jsx(QuestionDisplayAsCarousel, {
        items: carouselItems,
        activeQuestionIndex: selectedQuestionIndex,
        onQuestionIndexChange: function onQuestionIndexChange(idx) {
          return dispatch({
            type: UPDATE_SELECTED_QUESTION_INDEX,
            payload: {
              selectedQuestionIndex: idx
            }
          });
        },
        onPreviousSection: onPreviousSection,
        onNextSection: onNextSection,
        isFirstSection: isFirstSection,
        isLastSection: isLastSection,
        navigationLabels: {
          previousSection: navigationLabels === null || navigationLabels === void 0 ? void 0 : navigationLabels.previousSection,
          nextSection: navigationLabels === null || navigationLabels === void 0 ? void 0 : navigationLabels.nextSection,
          previousQuestion: 'Previous Question',
          nextQuestion: 'Next Question'
        }
      })]
    }) : /*#__PURE__*/_jsx(QuestionDisplayAsList, {
      onPreviousSection: onPreviousSection,
      onNextSection: onNextSection,
      isFirstSection: isFirstSection,
      isLastSection: isLastSection,
      navigationLabels: navigationLabels,
      children: renderQuestions()
    })]
  });
};